<template>
  <div class="wrapper news-mac">
    <header>
      <div class="main">
        <div class="banner"></div>

        <div class="left"></div>
        <div class="center"></div>
        <div class="right"></div>
      </div>
    </header>

    <main>
      <div class="main contentWrapper">
        <div class="center contentWrapper-content">
          <div class="news-left">
            <ul>
              <li
                class="change"
                :class="currentIndex == index ? 'active' : ''"
                v-for="(item, index) in list"
                :key="item.id"
                @click="change(index)"
              >
                <router-link :to="{ path: `${item.gopath}` }" class="color">{{
                  item.title
                }}</router-link>
              </li>
            </ul>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </main>

    <Footer class="footer"></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "newscenter",
  data() {
    return {
      currentIndex: 0, //表示当前选项卡,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: "最新消息", //标题
          gopath: "/newscenter/newlist"
        },
        {
          id: 2,
          title: "集团公告", //标题
          gopath: "/newscenter/newlist2"
        },
        // {
        //   id: 3,
        //   title: "信息披露", //标题
        //   gopath: "/newscenter/newlist3"
        // },
        {
          id: 3,
          title: "公司动态", //标题
          gopath: "/newscenter/newlist4"
        }
      ]
    };
  },
  methods: {
    change(index) {
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index;
    }
  }
};
</script>
<style scoped>
.contentWrapper-content {
  justify-content: space-between !important;
}
/* .wrapper{
  position: relative;
  width: 100%;
  min-height: 100%;
  padding-bottom:  260px;
  bottom: 0px;
  left: 0px;
  box-sizing: border-box;
}
.footer{
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background-color: red;
} */
@media screen and (max-width: 1295px) {
  body .all {
    width: 90%;
  }
  body .news-left {
    margin-right: 10px;
  }
}
header {
  height: 231px;
}
header .banner {
  background: url(../assets/img/新闻中心_banner.png) no-repeat;
  background-size: 100% 100%;
}
main {
  margin-bottom: 100px;
}
main .center {
  display: flex;
  margin-top: 56px;
  justify-content: center;
}
.news-left {
  width: 100px;
}
.news-left li {
  margin-bottom: 14px;
  /* font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.22);
  line-height: 21px; */
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #140047;
  line-height: 28px;
}
.news-left .active {
  color: #140047 !important;
}
.news-left .active a {
  opacity: 1;
  color: #140047 !important;
}
.news-left li a {
  color: rgba(0, 0, 0, 0.22);
  transition: color 0.3s;
}
.news-left li a:hover {
  color: #140047;
}
.news-right {
  flex: 1;
}
.news-right h1 {
  margin-bottom: 16.992px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.news-right .line {
  margin-bottom: 32.0064px;
  width: 100%;
  height: 1.9968px;
  background: #efeff2;
  opacity: 0.5;
}
.news .news-box {
  margin-bottom: 25.9968px;
  display: flex;
  width: 100%;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(176, 183, 213, 0.2);
  transition: transform 0.3s;
  cursor: pointer;
}
.news .news-box:hover {
  transform: scale(1.005);
  box-shadow: 0rem 4.992px 20.0064px 0rem rgba(176, 183, 213, 0.2);
}
.news .news-box:last-child {
  margin-bottom: 60px;
}
.news-box .news-date {
  padding: 49px 36px;
  border-right: 0.9984px solid #ecf0f2;
}
.news-date p:nth-child(1) {
  margin-bottom: 10.0032px;
  font-size: 36px;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 42px;
  letter-spacing: 1.92px;
}
.news-date p:nth-child(2) {
  margin-bottom: 2.9952px;
  font-size: 16px;
  font-weight: bold;
  color: #1d1d1d;
  opacity: 0.5;
  line-height: 19px;
  letter-spacing: 0.96px;
  white-space: nowrap;
}
.news-date p:nth-child(3) {
  width: 16.992px;
  height: 1.9968px;
  background: #ffa200;
}
.news-box .news-text {
  padding: 45px 40px;
}
.news-text h2 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.96px;
}
.news-text p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 20.0064px;
  letter-spacing: 0.96px;
}
.news-right .pages {
  margin: 0 auto;
  display: flex;
  width: 600px;
  justify-content: space-between;
  align-items: center;
}
.news-right .pages {
  display: flex;
}
.pages button {
  width: 32.0064px;
  height: 32.0064px;
  background: transparent;
  border-radius: 6.0096px;
  border: 0.9984px solid #dddddd;
  font-size: 13.9968px;
  color: #666666;
  line-height: 22.0032px;
  transition: background-color 0.3s;
}
.pages button:first-child .img {
  width: 10.0032px;
  height: 13.9968px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7bd3b3ca78332483ef7acdff03f316330bc26ef98ca1d55de2428c1359e2bda5)
    100% no-repeat;
  background-size: 100% 100%;
}
.pages button:nth-child(12) .img {
  width: 10.0032px;
  height: 13.9968px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7bd3b3ca78332483ef7acdff03f316330bc26ef98ca1d55de2428c1359e2bda5)
    100% no-repeat;
  background-size: 100% 100%;
  transform: rotateY(180deg);
}
.pages button:hover {
  color: white;
  background-color: #140047;
}
.pages div {
  width: 20.0064px;
  margin: 0 10.0032px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pages div span {
  width: 3.9936px;
  height: 3.9936px;
  background: #dddddd;
  border-radius: 3.9936px;
}
.pages p {
  margin-left: 15.9936px;
  display: flex;
  align-items: center;
}
.pages p input {
  margin: 0 8.0064px;
  width: 48px;
  height: 32.0064px;
  background: transparent;
  border-radius: 3.9936px;
  border: 0.9984px solid #dddddd;
}
/* .news-left {
  height: 100px;
  position: sticky;
  top: 100px;
} */
</style>



// WEBPACK FOOTER //
// src/components/newscenter.vue